import { dateFilter, services } from '@/utils'

import { getChannelTypes } from '@/components/services/otp-settings/utils'

import render from './render'

export default {
  name: 'Filters',

  mixins: [ dateFilter ],

  computed: {
    channelTypes() {
      return getChannelTypes(services['otp-settings/templates']).map(value => {
        return {
          title: this.getTranslate(`${services.sendings}.types.${value}`),
          value
        }
      })
    }
  },

  render
}
